import { render, staticRenderFns } from "./SalesReturnListItem.vue?vue&type=template&id=6d4f8e98&"
import script from "./SalesReturnListItem.vue?vue&type=script&lang=js&"
export * from "./SalesReturnListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "SalesReturnListItem.vue"
export default component.exports